






























































































































































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import {UtilitiesFunctions} from "../../helpers";
import SearchFiltersInfo from "@/components/filters/SearchFiltersInfo.vue";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import ClickOutside from 'vue-click-outside';
import AdvancedFiltersMenu from '@/components/filters/advanced-filters-menu/AdvancedFiltersMenu';
import AdvancedFilterSelection from '@/components/filters/AdvancedFilterSelection';
import AdvancedFiltersMobileDialog
  from '@/components/filters/advanced-filters-mobile-dialog/AdvancedFiltersMobileDialog';

@Component({
  components: {
    AdvancedFiltersMobileDialog,
    SearchFiltersInfo,
    AdvancedFiltersMenu,
  },
  directives: {
    ClickOutside
  }
})
export default class SearchFilters extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;

  @Prop({default: []}) private value!: Array<any>;
  @Prop({default: []}) private filtersCallBack!: Array<any>;
  @Prop({default: "0"}) private totalResults!: String;
  @Prop({default: true}) private showTags!: boolean;
  @Prop({default: true}) private showCount!: boolean;
  @Prop({default: 'large'}) private screenSize!: string;

  showMap: boolean = false;

  @Emit('showMapChange')
  showMapChange(v: boolean) {
    return v;
  }

  on: any = {};
  filters: any[] = [];
  showAdvancedFilters: boolean = false;

  // holds the temporary selection for the current selected items
  temporarySelection: { [k: number]: any[] } = {};

  // holds the 'filter item' that has the languages value
  languagesFilterItem: any = {};
  servicesFilterItem: any = {};
  priceMinFilterItem: any = {};
  priceMaxFilterItem: any = {};
  dateFilterItem: any = {};
  dateMenu!: any;

  date: any = [];

  mounted() {
    let skipFilterList = ['price_min', 'price_max', 'language_ids', 'service_ids'];
    this.showAdvancedFilters = this.$route.name === 'experiences';

    this.filters = this.value.filter(filter => {
      return filter.type !== 'input' && !skipFilterList.includes(filter.queryParam)
    })
    for (let item of this.value) {
      switch (item.queryParam) {
        case 'language_ids':
          this.languagesFilterItem = item;
          break;
        case 'service_ids':
          this.servicesFilterItem = item;
          break;
        case 'price_min':
          this.priceMinFilterItem = item;
          break;
        case 'price_max':
          this.priceMaxFilterItem = item;
          break;
        default: break;
      }
      if (item.type == 'inputDate') {
        this.dateFilterItem = item;
      }
    }
    setTimeout(() => this.hookSelects(), 100);
    //   const array: any = this.$refs.testref;
    //   // this.test = array[0].parentElement.className;
    //   array[0].parentElement.className = "v-label theme--light";
  }

  hookSelects() {
    for (let item of this.filters) {
      this.temporarySelection[item.id] = item.selectedVal;

      const dateMenuRef = this.$refs[`filterDateSelect_${this.screenSize}_${item.id}`] as any;
      if (dateMenuRef) this.dateMenu = dateMenuRef[0];

      const ref = this.$refs[`filterSelect_${this.screenSize}_${item.id}`] as any,
            vSelect = ref ? ref[0] : null;

      if (!vSelect) continue;

      // overrides close conditional so it does not close when blurred but rather when we ask it to.
      vSelect.closeConditional = () => false;

      // adjust temporary selection according to selections passed in
      vSelect.setValue(item.selectedVal);
    }
  }

  private isMultiple(item: any): boolean {
    if ('multiple' in item) {
      return item.multiple;
    }
    return true;
  }

  handleAppendClick(id: any) {
    // @ts-ignore
    this.$refs[`filterSelect_${this.screenSize}_${item.id}`][0].blur();
  }

  applyAdvancedSelection(selection: AdvancedFilterSelection) {
    this.temporarySelection[this.languagesFilterItem.id] = selection.language as any;
    this.languagesFilterItem.selectedVal = selection.language;
    this.temporarySelection[this.servicesFilterItem.id] = selection.service as any;
    this.servicesFilterItem.selectedVal = selection.service;
    this.priceMaxFilterItem.value = selection.maxPrice ? (selection.maxPrice * 100).toFixed() : '999999999';
    this.priceMinFilterItem.value = selection.minPrice ? (selection.minPrice * 100).toFixed() : '0';
    this.filtersCallBack[0].processFiltersCallback();
    /* TODO: price */
  }

  getSelectedLabel(item: any): string {
    return (this.isMultiple(item)) ? item.label : item.selectedVal.name;
  }

  clearFilters() {
    setTimeout(() => {
      this.filtersCallBack[0].processFiltersCallback();
    }, 0);
  }

  onClearClicked(item: any) {
    const ref = this.$refs[`filterSelect_${this.screenSize}_${item.id}`] as any,
          vSelect = ref ? ref[0] : null;
    if (vSelect) vSelect.clearableCallback();
    console.log(this.dateMenu);
    if (item.type === 'inputDate') {
      this.date = [];
      this.temporarySelection[item.id] = this.date = [];
      this.dateMenu.isActive = false;
    }
    item.selectedVal = this.temporarySelection[item.id];
    this.filtersCallBack[0].processFiltersCallback();
    setTimeout(() => this.hideContainer(item.id), 100);
  }

  onApplyClicked(item: any) {
    if (this.date && this.date.length) {
      this.temporarySelection[this.dateFilterItem.id] = this.date;
    }
    item.selectedVal = this.temporarySelection[item.id];
    this.filtersCallBack[0].processFiltersCallback();
    this.dateMenu.isActive = false;
    this.hideContainer(item.id);
  }

  onOutsideClicked(item: any) {
    // restore selection when clicked outside
    this.temporarySelection[item.id] = item.selectedVal;
    this.hideContainer(item.id);
  }

  onMousedown(id: number) {
    // mobile v-select refuses to close when clicked on activator, so we force it
    // in this case where the user does not have space to deselect something
    if (this.screenSize === 'large') return;
    const vSelect = (this.$refs[`filterSelect_${this.screenSize}_${id}`] as any)[0];
    if (vSelect.isMenuActive) {
      this.hideContainer(id)
    }
  }

  hideContainer(id: number) {
    const container: Element = (this.$refs[`filter-menu-container-${this.screenSize}-${id}`] as Element[])[0],
          ref = this.$refs[`filterSelect_${this.screenSize}_${id}`] as any,
          vSelect = ref ? ref[0] : null;
    if (vSelect && vSelect.isMenuActive) {
      container.classList.add('hide');
      (this.$refs[`filterSelect_${this.screenSize}_${id}`] as any)[0].blur();
    }
  }

  onFocus(id: number) {
    this.showContainer(id);
  }

  showContainer(id: number) {
    const container: Element = (this.$refs[`filter-menu-container-${this.screenSize}-${id}`] as Element[])[0],
          vSelect            = (this.$refs[`filterSelect_${this.screenSize}_${id}`] as any)[0];
    container.classList.remove('hide');
  }

  toggleContainer(id: number) {
    const container: Element = (this.$refs[`filter-menu-container-${this.screenSize}-${id}`] as Element[])[0],
          vSelect            = (this.$refs[`filterSelect_${this.screenSize}_${id}`] as any)[0];
    container.classList.add('hide');
  }

  updateSinglePicker(id: string, date: string) {
    /*  if (id && date) {
            const index = this.value.findIndex((item: any) => item.id === id);
            const updatedValue = this.value.slice();
            updatedValue[index].value = date;
            this.$emit("input", updatedValue);
          }*/
  }
}
